/**
 * Realtime WebSocket feature config (build-time env).
 * Off by default — set REACT_APP_REALTIME_WS_ENABLED=true|1 to enable.
 */

const isTruthyEnv = (value) => {
    if (value === true || value === 1) return true;
    if (value == null) return false;
    const normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
};

export const DEFAULT_REALTIME_WS_URL = 'ws://localhost:8081';

const isChatExecuteApiUrl = (value) =>
    typeof value === 'string' && value.includes('execute-api');

/** @returns {boolean} whether dashboard/notification realtime WS is enabled */
export const isRealtimeWsEnabled = () => isTruthyEnv(process.env.REACT_APP_REALTIME_WS_ENABLED);

/**
 * Realtime gateway URL. Prefer REACT_APP_REALTIME_WS_URL so chat's
 * REACT_APP_WS_URL (API Gateway execute-api) is never reused.
 * @returns {string}
 */
export const getRealtimeWsUrl = () => {
    const dedicated = process.env.REACT_APP_REALTIME_WS_URL;
    if (dedicated && String(dedicated).trim()) {
        return String(dedicated).trim();
    }
    const fallback = process.env.REACT_APP_WS_URL;
    if (fallback && String(fallback).trim() && !isChatExecuteApiUrl(fallback)) {
        return String(fallback).trim();
    }
    return DEFAULT_REALTIME_WS_URL;
};

/**
 * Connection policy (frontend):
 * - At most **one** realtime WebSocket per browser tab in the host app.
 * - OpenKnots embedded in the host must use the `129knots:realtime` event relay (no second socket).
 * - Standalone OpenKnots may open its own single socket.
 * - Multiple tabs ⇒ one socket each (expected).
 */
